export default "__VITE_ASSET__CaGDxpKF__"